module.exports = __webpack_public_path__ + "img/tretdetetaff.e9e52632.svg";